<template>
  <div>
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <h3 style="margin-top: 8px">{{ $i18n.t("lotes.consultar") }}</h3>
        <div>
          <CButton
            color="info"
            style="display: inline-block"
            @click="showFiltrosCampo = true"
            >Filtrar columnas</CButton
          >

          <CustomExport
            :lista="listaLotesFiltrados"
            style="display: inline-block"
            :fields="camposLotes"
            :name="'Listado de lotes'"
          ></CustomExport>
        </div>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          hover
          :itemsPerPageSelect="{
            label: 'Elementos por página',
            values: [5, 10, 15, 20, 25],
          }"
          :items-per-page="5"
          striped
          column-filter
          :items="listaLotesFiltrados"
          :fields="camposLotesFiltrados"
          :columnFilter='{ external: true, lazy: true }'
          :column-filter-value.sync="columnFilterVal"
          :tableFilter="{ placeholder: 'Introducir valor', label: 'Buscar', external: true, lazy: true }"
          :table-filter-value.sync="tableFilterVal"
          sorter
          pagination
        >
          <template #descripcionEstadoLote="{ item }">
            <td>
              <CBadge :color="getBadgeEstado(item.descripcionEstadoLote)">{{
                item.descripcionEstadoLote
              }}</CBadge>
            </td>
          </template>
          <template #precioDiaSinIVA="{ item }">
            <td>
              {{ item.precioDiaSinIVA ? item.precioDiaSinIVA : 0 }}
              €
            </td>
          </template>
          <template #presupuestoLicitacionSinIVA="{ item }">
            <td>
              {{
                item.presupuestoLicitacionSinIVA
                  ? item.presupuestoLicitacionSinIVA
                  : 0
              }}
              €
            </td>
          </template>
          <template #presupuestoLicitacionConIVA="{ item }">
            <td>
              {{
                item.presupuestoLicitacionConIVA
                  ? item.presupuestoLicitacionConIVA
                  : 0
              }}
              €
            </td>
          </template>
          <template #valorContratoSinIVA="{ item }">
            <td>
              {{ item.valorContratoSinIVA ? item.valorContratoSinIVA : 0 }}
              €
            </td>
          </template>
          <template #valorContratoConIVA="{ item }">
            <td>
              {{ item.valorContratoConIVA ? item.valorContratoConIVA : 0 }}
              €
            </td>
          </template>
          <template #acciones="{ item }">
            <td>
              <CButton color="info" @click="verDetallesLote(item.id)">Detalles</CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>

    <CModal
      title="Filtrar columnas de la tabla"
      :show.sync="showFiltrosCampo"
      size="lg"
      centered
    >
      <CRow>
        <CCol v-for="(campo, index) in camposLotes" :key="index" sm="6" v-if="campo.key !='acciones'"
          ><CInputCheckbox
            :label="campo.label"
            :checked="camposLotesFiltrados.indexOf(campo) > -1"
            @change="setFiltroCampoValue(campo)"
        /></CCol>
      </CRow>

      <template #footer>
        <CButton @click="showFiltrosCampo = false" color="info"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style scoped>
</style>

<script>
import Cookies from "js-cookie";
import { getAllLotes } from "../../requests/lotes";
import { logOut } from "../../utils/authUtils";
import { setTableFilterValue, setColumnFilterValue } from '../../utils/filterUtils'
import CustomExport from "../../utils/CustomExport";

export default {
  name: "ConsultarLotes",
  components: {
    CustomExport,
  },
  created() {},
  mounted() {
   
    this.camposLotesFiltrados = Array.from(this.camposLotes);

    getAllLotes()
      .then((res) => {
        this.listaLotes = res.data;
        this.listaLotesFiltrados = this.listaLotes;
        // console.log(this.listaLotes)
      })
      .catch((error) => {
        console.log(error.response.status);
        if (error.response.status == 403) {
          logOut(this.$router);
        }
      });
  },
  data() {
    return {
      listaLotes: [], //lista de lotes
      listaLotesFiltrados: [],
      columnFilterVal: {},
      tableFilterVal: "",
      showFiltrosCampo: false,
      camposLotesFiltrados: [], //campos de la tabla lotes que se muestran, como se puede filtrar esta lista contiene los campos seleccionados
      camposLotes: [ //campos base de la tabla de los lotes
        { key: "acciones", label: "Acciones" },
        {
          key: "nombreConcurso",
          field: "Concurso",
          label: "Concurso",
        },
        {
          key: "nombreExpediente",
          field: "Expediente",
          label: "Expediente",
        },
        { key: "numero", field: "Número de lote", label: "Número de lote" },
        { key: "codigoRuta", field: "Código ruta", label: "Código ruta" },
        {
          key: "descripcionTipoLote",
          field: "Tipo del lote",
          label: "Tipo del lote",
        },
        {
          key: "nombreProvincias",
          field: "Provincia",
          label: "Provincia",
        },
        {
          key: "descripcionEstadoLote",
          field: "Estado",
          label: "Estado",
        },
        {
          key: "descripcionTramoTarifario",
          field: "Tramo tarifario",
          label: "Tramo tarifario",
        },
        {
          key: "numeroRuta",
          field: "Número de ruta",
          label: "Número de ruta",
        },
        {
          key: "descripcionNivel",
          field: "Nivel",
          label: "Nivel",
        },
        {
          key: "numPlazasPrevistas",
          field: "Plazas Previstas",
          label: "Plazas Previstas",
        },
        {
          key: "descripcionVehiculoAdaptado",
          field: "Requiere Vehículo Adaptado",
          label: "Requiere Vehículo Adaptado",
        },
        {
          key: "km",
          field: "Kilómetros",
          label: "Kilómetros",
        },
        {
          key: "diasSeptNov",
          field: "Dias SEP-NOV",
          label: "Dias SEP-NOV",
        },
        {
          key: "diasDicJun",
          field: "Dias DIC-JUN",
          label: "Dias DIC-JUN",
        },       
        {
          key: "precioDiaSinIVA",
          field: "Precio día",
          label: "Precio día",
        },
        {
          key: "presupuestoLicitacionSinIVA",
          field: "Presupuesto licitación sin IVA",
          label: "Presupuesto licitación sin IVA",
        },
        {
          key: "valorContratoSinIVA",
          field: "Valor estimado contrato",
          label: "Valor estimado contrato",
        },
      ],
    };
  },
  computed: {
    tableState() {
      return [
        this.columnFilterVal,
        this.tableFilterVal,
      ];
    }
  },
  watch: {
    tableState() {
      this.listaLotesFiltrados = this.listaLotes
      this.setColumnFilter();
      this.setTableFilter();
    }
  },
  methods: {
    setColumnFilter() {
      this.listaLotesFiltrados = setColumnFilterValue(this.columnFilterVal, this.listaLotesFiltrados)
      // console.log(this.lotesOfertadosFiltrados);
      // console.log("this.lotesOfertadosFiltrados columna");
    },
    setTableFilter() {
      this.listaLotesFiltrados = setTableFilterValue(this.tableFilterVal, this.listaLotesFiltrados)
      // console.log(this.lotesOfertadosFiltrados);
      // console.log("this.lotesOfertadosFiltrados tabla");
    },
    //pendientes de ser modificados para ver que colores se eligen, son el color de los cartelitos de estado
    getBadgeEstado(situacion) {
      switch (situacion) {
        case "Sin Asignar":
          return "danger";
        case "Asignado Pendiente Validar":
          return "info";
        case "Asignado Pendiente Desempate":
          return "warning";
        case "Asignado Validado":
          return "success";
        case "Adjudicado":
          return "success";
        case "Asignado Pendiente Subsanación":
          return "warning";
        case "Desistido o renunciado":
          return "danger";
        case "Desierto":
          return "danger";
        default:
          return "warning";
      }
    },
    setFiltroCampoValue(campo) { //cuando se marca o desmarca un checkbox este añade o elimina de la lista de campos filtrados
      if (this.camposLotesFiltrados.indexOf(campo) > -1) {
        this.camposLotesFiltrados.splice(
          this.camposLotesFiltrados.indexOf(campo),
          1
        );
      } else this.camposLotesFiltrados.push(campo);
    },
    verDetallesLote(idLote){
      this.$router.push({ path: "/lotes/detalle?id=" + idLote }); //a los detalles del lote
    }
  },
  beforeDestroy() {},
};
</script>
